import { assertFlagStatusName } from './internal/assertFlagStatusName';

export function ensureFlagStatusName(name: unknown) {
  assertFlagStatusName(name);
  return name;
}
